import { render, staticRenderFns } from "./XinLv.vue?vue&type=template&id=76ad9e46&scoped=true&"
import script from "./XinLv.vue?vue&type=script&lang=js&"
export * from "./XinLv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad9e46",
  null
  
)

export default component.exports